import { Navigate } from 'react-router-dom';

export function LogoutPage() {
  localStorage.removeItem('user');

  return <Navigate to="/admin/login" />;
}
